import React from 'react';
import {
  FitnessCenter as TrainingIcon,
  EmojiEvents as TournamentIcon,
  Groups as ActivityIcon,
} from '@mui/icons-material';

export const EVENT_TYPES = [
  { value: 'training',   label: 'Training',  icon: <TrainingIcon fontSize="small" />,   color: '#1565C0' },
  { value: 'turnier',    label: 'Turnier',   icon: <TournamentIcon fontSize="small" />, color: '#6A1B9A' },
  { value: 'aktivitaet', label: 'Aktivität', icon: <ActivityIcon fontSize="small" />,   color: '#2E7D32' },
];

export const WEEKDAYS = [
  { value: 'Mo', label: 'Mo', jsDay: 1 }, { value: 'Di', label: 'Di', jsDay: 2 },
  { value: 'Mi', label: 'Mi', jsDay: 3 }, { value: 'Do', label: 'Do', jsDay: 4 },
  { value: 'Fr', label: 'Fr', jsDay: 5 }, { value: 'Sa', label: 'Sa', jsDay: 6 },
  { value: 'So', label: 'So', jsDay: 0 },
];

export const RECURRING_INTERVALS = [
  { value: 1, label: 'Wöchentlich' },
  { value: 2, label: 'Alle 2 Wochen' },
  { value: 3, label: 'Alle 3 Wochen' },
  { value: 4, label: 'Alle 4 Wochen' },
];

export const POSITIONS = ['Sturm', 'Verteidigung', 'Deckel'];

export const UWR_LINKS = [
  { category: 'Verband', links: [
    { label: 'CMAS (Weltverband)', url: 'https://www.cmas.org/underwater-rugby', desc: 'Internationaler Tauchsportverband' },
    { label: 'VDST (Deutscher Verband)', url: 'https://www.vdst.de/sporttauchen/unterwasserrugby/', desc: 'Verband Deutscher Sporttaucher' },
    { label: 'WLT (Württembergischer Verband)', url: 'https://www.wltev.de/sachabteilungen/uw-rugby.html', desc: 'Württembergischer Landesverband' },
    { label: 'UWR Heilbronn', url: 'https://www.tauchclubheilbronn.de/sparten/unterwasserrugby/', desc: 'Tauchclub Heilbronn Sparte Unterwasserrugby' },
  ]},
  { category: 'Spielbetrieb', links: [
    { label: 'UWR1.de Blog', url: 'https://www.uwr1.de', desc: 'Aktuelles aus dem deutschen Unterwasserrugby' },
    { label: 'UWR1.de Ergebnisse', url: 'http://uwr1.de/ergebnisse', desc: 'Ergebnisse und Ranglisten' },
  ]},
  { category: 'Regeln & Wissen', links: [
    { label: 'UWR auf Wikipedia (DE)', url: 'https://de.wikipedia.org/wiki/Unterwasserrugby', desc: 'Einführung ins Spiel, Geschichte, Regeln' },
    { label: 'VDST UWR Regeln', url: 'https://www.vdst.de/download/regelwerk-uwr-2020/?tmstv=1778395176', desc: 'Offizielle internationale Spielregeln (PDF)' },
    { label: 'VDST UWR Schiedsrichterordnung', url: 'https://www.vdst.de/download/schiedsrichterordnung-uwr/?tmstv=1778395176', desc: 'Offizielle Schiedsrichterordnung (PDF)' },
    { label: 'VDST UWR Wettkampfordnung', url: 'https://www.vdst.de/download/wettkampfordnung-uwr/?tmstv=1778395176', desc: 'Offizielle Wettkampfordnung (PDF)' },
  ]},
  { category: 'Community & Videos', links: [
    { label: 'UWR auf YouTube', url: 'https://www.youtube.com/results?search_query=underwater+rugby', desc: 'Spielaufzeichnungen und Highlights' },
    { label: 'YouTube Channel UWR Heilbronn', url: 'https://www.youtube.com/@nico_s_bertsch', desc: 'Videos aus Spielen und Trainings' },
    { label: 'r/UnderwaterRugby (Reddit)', url: 'https://www.reddit.com/r/UnderwaterRugby/', desc: 'Community-Diskussionen' },
  ]},
];

export const FILTERS = [
  { value: 'offen',      label: 'Offen'     }, { value: 'zusage',     label: 'Zugesagt'  },
  { value: 'absage',     label: 'Abgesagt'  }, { value: 'neu',        label: 'Neu'       },
  { value: 'training',   label: 'Training'  }, { value: 'turnier',    label: 'Turnier'   },
  { value: 'aktivitaet', label: 'Aktivität' },
];

export const PLAYER_POS_FILTERS = [
  { value: 'pos1-Sturm',        label: 'Sturm (1.)' },
  { value: 'pos1-Verteidigung', label: 'Verteidigung (1.)' },
  { value: 'pos1-Deckel',       label: 'Deckel (1.)' },
  { value: 'pos2-Sturm',        label: 'Sturm (2.)' },
  { value: 'pos2-Verteidigung', label: 'Verteidigung (2.)' },
  { value: 'pos2-Deckel',       label: 'Deckel (2.)' },
  { value: 'schiri',            label: 'Schiedsrichter' },
  { value: 'noteam',            label: 'Kein Team' },
];

export const EXCLUSIVE_FILTER_GROUPS = [
  ['team-Damen', 'team-Herren'],
  ['pos1-Sturm', 'pos1-Verteidigung', 'pos1-Deckel'],
  ['pos2-Sturm', 'pos2-Verteidigung', 'pos2-Deckel'],
];

export const SKILL_LABELS = [
  { key: 'defense',      label: 'Defence' },
  { key: 'scoring',      label: 'Offence' },
  { key: 'deckel',       label: 'Deckel' },
  { key: 'verteidigung', label: 'Verteidigung' },
  { key: 'sturm',        label: 'Sturm' },
  { key: 'oneOnOne',     label: '1 gegen 1' },
  { key: 'positioning',  label: 'Positionsspiel' },
  { key: 'availability', label: 'Verfügbarkeit' },
  { key: 'fitness',      label: 'Fitness' },
  { key: 'teamplay',     label: 'Teamspiel' },
];

export const emptyEvent = {
  name: '', type: 'training', date: '', startTime: '', endTime: '', endDate: '',
  location: '', description: '',
  recurring: false, recurringInterval: 1, recurringDays: [], recurringEndDate: '', invitedPlayerIds: [],
  fullDay: false,
};

export const emptyPlayer = {
  firstName: '', lastName: '', capNumber: '', nickname: '',
  gender: '',
  birthday: '', birthmonth: '', birthyear: '',
  email: '',
  street: '', streetNumber: '', cityCode: '', city: '',
  primaryPosition: '', secondaryPosition: '',
  team: '',
  playerPassNumber: '',
  isReferee: false, refereePassNumber: '',
  skillStats: { defense: '', scoring: '', deckel: '', verteidigung: '', sturm: '', oneOnOne: '', positioning: '', availability: '', fitness: '', teamplay: '' },
};
